/* eslint-disable react/destructuring-assignment */
import React from 'react';

export default function columns(t) {
  const redColor = { color: '#E15800' };
  const blueColor = { color: '#202BA2' };

  return [
    { title: t('general.date'), field: 'dateInFormat' },
    { title: t('general.receipts'), field: 'description' },
    { title: t('general.student'), field: 'studentName' },
    {
      title: t('general.value'),
      field: 'formattedValue',
      render: (rowData) => {
        return (
          <p style={rowData.value > 0 ? blueColor : redColor}>
            {rowData.formattedValue}
          </p>
        );
      },
    },
    { title: t('general.financial-contact'), field: 'responsibleName' },
    { title: t('general.due-date'), field: 'invoiceDueDateInFormat' },
  ];
}
